import { isAuth } from './utils/auth';
import SiteLayout from './layouts/SiteLayout';
import RequiredRole from './utils/RequiredRole';
import ProviderLayout from './layouts/ProviderLayout';
import AdminLayout from './layouts/AdminLayout';
import GovLayout from './layouts/GovLayout';
import { Route, Routes } from 'react-router-dom';
import AuthLayout from './layouts/AuthLayout';

function Main() {
  let auth = isAuth()

  return (
    <>
      <Routes>
        <Route path="/*" element={<SiteLayout />} />
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="/provider/*" element={<RequiredRole allowed={3}><ProviderLayout /></RequiredRole>} />
        <Route path="/admin/*" element={<RequiredRole allowed={1}><AdminLayout /></RequiredRole>} />
        <Route path="/admingov/*" element={<RequiredRole allowed={[1,5,6,7,8,9,10,11]}><GovLayout /></RequiredRole>} />
      </Routes>
    </>
  );
}

export default Main;